import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v1';
import { Bert } from 'meteor/themeteorchef:bert';
import {
  Alert,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  FormControl,
  FormGroup,
  FormControlLabel,
  Grid,
  MenuItem,
  Paper,
  Select,
  Stack,
  styled,
  Switch,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Pagination
} from '@mui/material';
import { isEmpty } from 'lodash';

import ISLComponentModal from '../ISLComponentModal';
import UploadFileISLComponent from './UploadFileISLComponent';
import NewFunctionISL from '../NewFunctionISL';
import useTimeStore from '../ZustandProvider';

const ISLComponent = ({ MapProps, isFullScreen, isMobile }) => {
  const { ipsOfIsl } = MapProps.map.settingsAdvancedMap;
  const drawerWidth = useTimeStore(state => state.drawerWidth);

  const [firstAnswer, setFirstAnswer] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [listOfProcess, setListOfProcess] = React.useState([]);
  const [openModal, setOpenModal] = React.useState(false);
  const [selectedOptions, setSelectedOptions] = React.useState('Processes');
  const [outputFormats, setOutputFormats] = React.useState([]);

  const [dataList, setDataList] = React.useState([]);

  const [page, setPage] = React.useState(0);
  const [valueToShow, setValueToShow] = React.useState({});
  const [templateList, setTemplateList] = React.useState([]);
  const [viewType, setViewType] = React.useState(ipsOfIsl.viewDefault);
  const itemsPerPage = isFullScreen || drawerWidth >= 50 ? 8 : 4;
  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const rowsPerPage = 10;
  const optionsComponent = ['Processes', 'Data'];

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: '#2A3F90',
      color: theme.palette.common.white
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14
    }
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    },
    '&:last-child td, &:last-child th': {
      border: 0
    }
  }));

  const StyledTable = styled(Table)(() => ({
    border: `1px solid #2A3F90`
  }));

  const MaterialUISwitch = styled(Switch)(({ theme }) => ({
    width: 70,
    height: 34,
    padding: 7,
    '& .MuiSwitch-switchBase': {
      margin: 1,
      padding: 0,
      transform: 'translateX(6px)',
      '&.Mui-checked': {
        color: '#2A3F90',
        transform: 'translateX(32px)',
        '& .MuiSwitch-thumb:before': {
          content: "''",
          position: 'absolute',
          width: 24,
          height: 24,
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="${encodeURIComponent(
            '#2A3F90'
          )}" d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM5 5h14v9l-4.5-4.5-3.5 3.5-2.5-2.5L5 14V5zm0 14v-2.5l4-4 2.5 2.5 3.5-3.5 4 4V19H5zm7-7c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/></svg>')`
        },
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.palette.mode === 'dark' ? '#fff' : '#7f8bbc'
        }
      }
    },
    '& .MuiSwitch-thumb': {
      backgroundColor: theme.palette.mode === 'dark' ? '#7f8bbc' : '#fff',
      width: 30,
      height: 30,
      '&::before': {
        content: "''",
        position: 'absolute',
        width: 24,
        height: 24,
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="${encodeURIComponent(
          '#2A3F90'
        )}" d="m3.25002,7.13637c0,-1.0092 0.86852,-1.82386 1.94444,-1.82386s1.94444,0.81466 1.94444,1.82386s-0.86852,1.82386 -1.94444,1.82386s-1.94444,-0.81466 -1.94444,-1.82386zm0,4.86363c0,-1.0092 0.86852,-1.82386 1.94444,-1.82386s1.94444,0.81466 1.94444,1.82386s-0.86852,1.82386 -1.94444,1.82386s-1.94444,-0.81466 -1.94444,-1.82386zm0,4.86363c0,-1.0092 0.86852,-1.82386 1.94444,-1.82386s1.94444,0.81466 1.94444,1.82386s-0.86852,1.82386 -1.94444,1.82386s-1.94444,-0.81466 -1.94444,-1.82386zm4.53703,-0.60795l12.96294,0l0,2.43181l-12.96294,0l0,-2.43181zm0,-4.86363l12.96294,0l0,2.43181l-12.96294,0l0,-2.43181zm0,-4.86363l12.96294,0l0,2.43181l-12.96294,0l0,-2.43181z"/></svg>')`
      }
    },
    '& .MuiSwitch-track': {
      opacity: 1,
      backgroundColor: theme.palette.mode === 'dark' ? '#fff' : '#7f8bbc',
      borderRadius: 20 / 2
    }
  }));

  const callToBackToList = async item => {
    // const nuevoObjeto = {};
    // Object.keys(item.variables).forEach(key => {
    //   nuevoObjeto[key] = item.variables[key].input;
    // });
    if (item.type === 'ISL') {
      let bodyConfiguration = {};
      if (item.type === 'ISL') {
        bodyConfiguration = {
          disk: 'data3',
          all_processes: true,
          guid_function: item.guid
          // De momento lista todos de todas las funciones
        };
      }
      //  else if (valueToShow.type === 'Airflow') {
      //   bodyConfiguration = {
      //     function: valueToShow.path,
      //     variables: nuevoObjeto
      //   };
      // }

      const response = await fetch(item.url, {
        method: 'POST',
        body: JSON.stringify(bodyConfiguration),
        headers: { 'Content-Type': 'application/json' },
        mode: 'cors',
        credentials: 'omit',
        referrerPolicy: 'no-referrer'
      });
      const respuesta = await response.json();
      setIsLoading(false);
      if (respuesta.status === 'OK') {
        setListOfProcess(respuesta.data);
      } else {
        Bert.alert(respuesta.data, 'danger');
      }
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const addPathToUrl = (urlProp, type) => {
    let url = urlProp;
    const pathISL = 'MG/isl/exec_isl';
    const pathAirflow = 'MG/airflow/exec_airflow';
    if (!url.endsWith('/')) {
      url += '/';
    }
    if (type === 'Airflow') {
      return url + pathAirflow;
    }
    if (type === 'ISL') {
      return url + pathISL;
    }
    return '';
  };

  const findAnswer = async item => {
    let bodyConfiguration = {};
    if (item.type === 'ISL') {
      bodyConfiguration = {
        disk: 'data3',
        functions_availables: true
      };
    } else if (item.type === 'Airflow') {
      bodyConfiguration = {
        function: 'FirstRequest'
      };
    }
    const response = await fetch(addPathToUrl(item.url, item.type), {
      method: 'POST',
      body: JSON.stringify(bodyConfiguration),
      headers: { 'Content-Type': 'application/json' },
      mode: 'cors',
      credentials: 'omit',
      referrerPolicy: 'no-referrer'
    });
    const respuesta = await response.json();

    if (!isEmpty(respuesta) && respuesta.status === 'OK') {
      setOutputFormats(respuesta.output_formats);
      return respuesta.data.map(elements => {
        return {
          ...elements,
          url: addPathToUrl(item.url, item.type),
          type: item.type,
          alias: '',
          description: ''
        };
      });
    }
    return [];
  };

  const listFunction = async bodyProp => {
    const object = ipsOfIsl.links.find(item => item.type === 'ISL');

    const bodyFunctions = () => {
      if (bodyProp === 'templates') {
        return { disk: 'data3', get_template: true };
      }
      if (bodyProp === 'data') {
        return { disk: 'data3', get_data_available: true };
      }
      return '';
    };

    const response = await fetch(addPathToUrl(object.url, object.type), {
      method: 'POST',
      body: JSON.stringify(bodyFunctions()),
      headers: { 'Content-Type': 'application/json' },
      mode: 'cors',
      credentials: 'omit',
      referrerPolicy: 'no-referrer'
    });
    const respuesta = await response.json();
    if (!isEmpty(respuesta) && respuesta.status === 'OK') {
      if (bodyProp === 'templates') {
        setTemplateList(respuesta.data);
      }
      if (bodyProp === 'data') {
        setDataList(respuesta.data);
      }
    }
  };

  const fetchAllAnswers = async () => {
    const allAnswers = await Promise.all(ipsOfIsl.links.map(findAnswer));
    const flattenedAnswers = allAnswers.flat();
    setFirstAnswer(flattenedAnswers);
  };

  React.useEffect(() => {
    const fetchData = async () => {
      await fetchAllAnswers();
      await listFunction('templates');
      await listFunction('data');
    };
    fetchData();
  }, []);
  return (
    <>
      <Box
        sx={{
          overflow: 'hidden',
          m: '2%',
          display: 'flex',
          flexDirection: 'column',
          height: '100%'
        }}
      >
        {!isEmpty(firstAnswer) && (
          <>
            <TableContainer component={Paper}>
              <StyledTable aria-label="customized table" size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>
                      <FormControl variant="standard" size="small" fullWidth>
                        <Select
                          labelId="select-label"
                          value={selectedOptions}
                          onChange={event => {
                            setSelectedOptions(event.target.value);
                            if (event.target.value === 'Data') {
                              listFunction('data');
                            } else if (event.target.value === 'Processes')
                              listFunction('templates');
                          }}
                          style={{ maxWidth: '150px', color: 'white' }}
                        >
                          {optionsComponent.map(option => (
                            <MenuItem key={option} value={option}>
                              {option}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </StyledTableCell>
                    <StyledTableCell>
                      {!isEmpty(templateList) && selectedOptions === 'Processes' && (
                        <NewFunctionISL templateList={templateList} ipsOfIsl={ipsOfIsl} />
                      )}
                      {selectedOptions === 'Data' && <UploadFileISLComponent ipsOfIsl={ipsOfIsl} />}
                    </StyledTableCell>
                    <StyledTableCell>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <MaterialUISwitch
                              checked={viewType === 'Imagenes'}
                              onChange={() => {
                                setViewType(viewType === 'Imagenes' ? 'Listado' : 'Imagenes');
                                setPage(viewType === 'Imagenes' ? 0 : 1);
                              }}
                            />
                          }
                          label=""
                        />
                      </FormGroup>
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
              </StyledTable>
            </TableContainer>
            {viewType === 'Imagenes' && selectedOptions === 'Processes' && (
              <>
                <Grid container spacing={1} justifyContent="center">
                  {firstAnswer.slice(startIndex, endIndex).map(item => (
                    <Grid
                      item
                      key={uuid()}
                      xs={12}
                      sm={itemsPerPage === 4 ? 6 : 3}
                      md={itemsPerPage === 4 ? 6 : 3}
                      lg={itemsPerPage === 4 ? 6 : 3}
                    >
                      {isMobile === true ? (
                        <Card
                          sx={{
                            display: 'flex',
                            borderRadius: 4,
                            margin: 'auto',
                            mb: 2
                            // maxWidth: 400
                          }}
                        >
                          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <CardContent
                              sx={{ flex: '1 0 auto', maxHeight: 140, overflowY: 'hidden' }}
                            >
                              <Typography component="div" variant="h6">
                                {item.name}
                              </Typography>
                            </CardContent>
                            <Box sx={{ alignItems: 'center', display: 'flex', pl: 1, pb: 1 }}>
                              <Button
                                size="small"
                                style={{ backgroundColor: '#2A3F90', color: 'white', margin: 0 }}
                                onClick={() => {
                                  const newVariables = {};
                                  Object.keys(item.variables).forEach(key => {
                                    const variable = item.variables[key];
                                    newVariables[key] = {
                                      ...variable,
                                      input: ''
                                    };
                                  });
                                  const newItem = { ...item, variables: newVariables };
                                  setValueToShow(newItem);
                                  callToBackToList(newItem);
                                  setOpenModal(true);
                                }}
                              >
                                Open
                              </Button>
                            </Box>
                          </Box>
                          <CardMedia
                            sx={{
                              flex: '0 0 auto',
                              height: 140,
                              width: 180,
                              maxWidth: 170,
                              backgroundSize: 'cover'
                            }}
                            image={item.image}
                            title={item.name}
                          />
                        </Card>
                      ) : (
                        <Card sx={{ maxWidth: 180, borderRadius: 4 }}>
                          <CardMedia
                            sx={{
                              height: 140,
                              width: 140,
                              justifyContent: 'center',
                              alignItems: 'center'
                            }}
                            image={item.image}
                            title={item.name}
                          />
                          <CardContent sx={{ maxHeight: 100, overflowY: 'hidden' }}>
                            <Typography gutterBottom variant="h6" component="div">
                              {item.name}
                            </Typography>
                          </CardContent>
                          <CardActions sx={{ justifyContent: 'center', padding: 0 }}>
                            <Button
                              size="small"
                              style={{ backgroundColor: '#2A3F90', color: 'white', mb: 1 }}
                              onClick={() => {
                                const newVariables = {};
                                Object.keys(item.variables).forEach(key => {
                                  const variable = item.variables[key];
                                  newVariables[key] = {
                                    ...variable,
                                    input: ''
                                  };
                                });
                                const newItem = { ...item, variables: newVariables };
                                setValueToShow(newItem);
                                callToBackToList(newItem);
                                setOpenModal(true);
                              }}
                            >
                              Open
                            </Button>
                          </CardActions>
                        </Card>
                      )}
                    </Grid>
                  ))}
                </Grid>

                <Stack
                  direction="row"
                  spacing={1}
                  sx={{
                    justifyContent: 'center'
                  }}
                >
                  <Pagination
                    count={Math.ceil(firstAnswer.length / itemsPerPage)}
                    page={page}
                    onChange={handleChangePage}
                    sx={{
                      '& .MuiPaginationItem-page.Mui-selected': {
                        backgroundColor: '#2A3F90',
                        color: 'white'
                      },
                      '& .MuiPaginationItem-page.Mui-selected .MuiPaginationItem-pageNumber': {
                        color: 'white'
                      }
                    }}
                  />
                </Stack>
              </>
            )}
            {viewType === 'Imagenes' && selectedOptions === 'Data' && (
              <Alert severity="info">Function in development.</Alert>
            )}
            {viewType === 'Listado' && (
              <>
                {selectedOptions === 'Processes' && (
                  <Box
                    component="form"
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      width: '100%',
                      mb: 2
                    }}
                    noValidate
                    autoComplete="off"
                  >
                    <Box sx={{ width: '100%', mb: 2 }}>
                      <TableContainer component={Paper}>
                        <StyledTable aria-label="customized table" size="small" stickyHeader>
                          <TableBody>
                            {firstAnswer
                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                              .map(row => (
                                <StyledTableRow key={row.name}>
                                  <StyledTableCell>{row.name}</StyledTableCell>
                                  <StyledTableCell>
                                    <Button
                                      size="small"
                                      aria-label="centrar"
                                      style={{
                                        color: '#2A3F90',
                                        padding: '4px 8px',
                                        borderRadius: 4,
                                        fontSize: 12,
                                        fontWeight: 'bold'
                                      }}
                                      onClick={() => {
                                        const newVariables = {};
                                        Object.keys(row.variables).forEach(key => {
                                          const variable = row.variables[key];
                                          newVariables[key] = {
                                            ...variable,
                                            input: ''
                                          };
                                        });
                                        const newItem = { ...row, variables: newVariables };
                                        setValueToShow(newItem);
                                        callToBackToList(newItem);
                                        setOpenModal(true);
                                      }}
                                    >
                                      Open
                                    </Button>
                                  </StyledTableCell>
                                </StyledTableRow>
                              ))}
                          </TableBody>
                        </StyledTable>
                      </TableContainer>
                    </Box>
                    <Box sx={{ width: '100%' }}>
                      <TablePagination
                        rowsPerPageOptions={[10]}
                        component="div"
                        count={firstAnswer.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                      />
                    </Box>
                  </Box>
                )}
                {selectedOptions === 'Data' && (
                  <>
                    <Box
                      component="form"
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        width: '100%',
                        mb: 2
                      }}
                      noValidate
                      autoComplete="off"
                    >
                      <Box sx={{ width: '100%', mb: 2 }}>
                        <TableContainer component={Paper}>
                          <StyledTable aria-label="customized table" size="small" stickyHeader>
                            <TableBody>
                              {dataList
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map(row => (
                                  <StyledTableRow key={row.data_name}>
                                    <StyledTableCell>{row.data_name}</StyledTableCell>
                                    <StyledTableCell>
                                      {/* <Button
                                      size="small"
                                      aria-label="centrar"
                                      style={{
                                        color: '#2A3F90',
                                        padding: '4px 8px',
                                        borderRadius: 4,
                                        fontSize: 12,
                                        fontWeight: 'bold'
                                      }}
                                      onClick={() => {
                                        const newVariables = {};
                                        Object.keys(row.variables).forEach(key => {
                                          const variable = row.variables[key];
                                          newVariables[key] = {
                                            ...variable,
                                            input: variable.type === 'File' ? '' : variable.example
                                          };
                                        });
                                        const newItem = { ...row, variables: newVariables };
                                        setValueToShow(newItem);
                                        callToBackToList(newItem);
                                        setOpenModal(true);
                                      }}
                                    >
                                      Open
                                    </Button> */}
                                    </StyledTableCell>
                                  </StyledTableRow>
                                ))}
                            </TableBody>
                          </StyledTable>
                        </TableContainer>
                      </Box>
                      <Box sx={{ width: '100%' }}>
                        <TablePagination
                          rowsPerPageOptions={[10]}
                          component="div"
                          count={firstAnswer.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          onPageChange={handleChangePage}
                        />
                      </Box>
                    </Box>
                  </>
                )}
              </>
            )}
          </>
        )}
      </Box>
      <ISLComponentModal
        isLoading={isLoading}
        isMobile={isMobile}
        listOfProcess={listOfProcess}
        openModal={openModal}
        setIsLoading={setIsLoading}
        setOpenModal={setOpenModal}
        setValueToShow={setValueToShow}
        valueToShow={valueToShow}
        dataList={dataList}
        outputFormats={outputFormats}
      />
    </>
  );
};

ISLComponent.defaultProps = {
  MapProps: {},
  isFullScreen: false
};
ISLComponent.propTypes = {
  isFullScreen: PropTypes.bool,
  isMobile: PropTypes.bool.isRequired,
  MapProps: PropTypes.object
};

export default ISLComponent;
